// It's placeholder for event delegator in new UI, will add event process function later
export class EventDelegator {
  on() {}

  trigger() {}

  off() {}
}
